import sample_1 from './twinstarProtectComplete.jpg';

export const twinstarProtectComplete = {
    sample_1,
};
